var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.491577,
    y: 0.0297852,
    width: 26.9401,
    height: 26.9401,
    rx: 13.47,
    fill: "url(#paint0_linear_1_441)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9606 6.896C5.53155 6.896 5.38403 7.64559 5.38403 13.4999C5.38403 19.3543 5.53155 20.1039 13.9606 20.1039C22.3896 20.1039 22.5372 19.3543 22.5372 13.4999C22.5372 7.64559 22.3896 6.896 13.9606 6.896ZM16.7094 13.7864L12.8585 15.5841C12.5215 15.7401 12.2453 15.5652 12.2453 15.193V11.8069C12.2453 11.4356 12.5215 11.2598 12.8585 11.4158L16.7094 13.2135C17.0464 13.3713 17.0464 13.6286 16.7094 13.7864Z",
    fill: "#FCFFFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_441",
    x1: 13.9616,
    y1: 0.0297852,
    x2: 13.9616,
    y2: 26.9699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CD8AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CD845"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.f203c2e691819c651cd55b7e0b42263d.svg";
export { ForwardRef as ReactComponent };